/**
 * Builds a readable message for a failed file upload. The reply is not always JSON (a proxy
 * in front of the server can answer with an HTML page, e.g. 413 "Request Entity Too Large"),
 * so it is read as text first and the HTTP status is used as the fallback.
 */
export async function describeUploadFailure(res: Response, fileName: string): Promise<string> {
  const body = await res.text().catch(() => '');
  let serverMessage = '';
  try {
    serverMessage = JSON.parse(body).error || '';
  } catch {
    // not JSON; use the status below
  }
  console.error('File upload failed:', res.status, body.slice(0, 500));

  if (serverMessage) return `Could not upload "${fileName}": ${serverMessage}`;
  if (res.status === 413) {
    return `Could not upload "${fileName}": the file is larger than the server or its proxy allows (HTTP 413).`;
  }
  return `Could not upload "${fileName}" (server responded ${res.status}${res.statusText ? ` ${res.statusText}` : ''}).`;
}
